import $ from 'jquery';
import 'picturefill';
import defaults from 'defaults';
import common from 'common';
import header from 'header';
import top from 'top';
import blog from 'blog';

let SF = SF || {
  isMobile  : true,
  ua        : {},
  scrollpos : 0,
  currentWidth : 0
};

$(window).on('resize', function(){
  if (SF.currentWidth === window.innerWidth) {
    return;
  }

  SF.isMobile = defaults.setIsMobile();
  SF.ua       = defaults.setUa();

  defaults.setViewport(SF.ua,1400);
  header.setRemoveNavigation(SF);
  top.setInstagram(SF);
  blog.switchSideList(SF);
});

$(window).on('scroll', function(){
  let _scroll = $(this).scrollTop();
  defaults.setToTop(_scroll);
  header.setFixedNavigation(_scroll);
});

$(window).on('load', function(){
  if (SF.isMobile) {
    defaults.setAnchor();
  } else {
    defaults.setAnchor(100);
  }
});

$(function(){
  SF.isMobile     = defaults.setIsMobile();
  SF.ua           = defaults.setUa();
  SF.currentWidth = window.innerWidth;

  defaults.setViewport(SF.ua,1400);
  common.setMailTo();
  header.setNavigation(SF);
  top.setInstagram(SF);
  blog.setSideList();
  blog.switchSideList(SF);
});

exports.initMap = () => {
  top.setGoogleMap();
};



// WEBPACK FOOTER //
// ./src/js/script.js